import User from 'records/User';

export const enum Permission {
  DEPT_STATS = 'can_view_dept_stats',
}

/**
 * Check if user has the given permission
 */
export function hasPermission(user: User, perm: Permission) {
  return user.permissions.some(p => perm === p);
}
